import { Card, CardContent } from '@/components/ui/card';
import { Edit } from 'lucide-react';

interface QuoteCardProps {
  quote?: string;
  author?: string;
  imageUrl?: string;
  isAdmin?: boolean;
  onEdit?: () => void;
}

export function QuoteCard({
  quote = 'Elke dag is een nieuwe kans om te groeien',
  author = 'Hoofd naar Hart',
  imageUrl = 'https://images.unsplash.com/photo-1519834785169-98be25ec3f84?q=80&w=1200',
  isAdmin = false,
  onEdit,
}: QuoteCardProps) {
  return (
    <Card className="overflow-hidden">
      <div className="relative h-[300px]">
        <img
          src={imageUrl}
          alt="Quote background"
          className="w-full h-full object-cover"
        />
        <div className="absolute inset-0 bg-black/40 flex flex-col items-center justify-center p-6 text-center text-white">
          <p className="text-xl font-serif italic mb-4">"{quote}"</p>
          <p className="text-sm font-medium">- {author}</p>
        </div>
        {isAdmin && onEdit && (
          <button
            onClick={onEdit}
            className="absolute top-2 right-2 bg-white/80 hover:bg-white p-2 rounded-full transition-colors"
            aria-label="Bewerk quote"
          >
            <Edit className="h-4 w-4 text-gray-700" />
          </button>
        )}
      </div>
    </Card>
  );
}
